import { render, staticRenderFns } from "./practicalExperiment.vue?vue&type=template&id=368404b6&scoped=true&"
import script from "./practicalExperiment.vue?vue&type=script&lang=js&"
export * from "./practicalExperiment.vue?vue&type=script&lang=js&"
import style0 from "./practicalExperiment.vue?vue&type=style&index=0&id=368404b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368404b6",
  null
  
)

export default component.exports